import { GridCard, GridCardProps } from './grid-card';
import { ListCard, ListCardProps } from './list-card';

export interface UnifiedCardProps {
  isGridLayout: boolean;
  gridProps?: Omit<GridCardProps, 'children'>;
  listProps?: Omit<ListCardProps, 'children'>;
  children?: React.ReactNode;
  className?: string;
}

export function UnifiedCard({
  isGridLayout,
  gridProps,
  listProps,
  children,
  className = ""
}: UnifiedCardProps) {
  if (isGridLayout && gridProps) {
    return (
      <GridCard {...gridProps} className={className}>
        {children}
      </GridCard>
    );
  }

  if (!isGridLayout && listProps) {
    return (
      <ListCard {...listProps} className={className}>
        {children}
      </ListCard>
    );
  }

  return (
    <div className={`bg-card rounded-lg shadow-sm border border-border hover:shadow-md transition-shadow p-6 ${className}`}>
      {children}
    </div>
  );
}

export { GridCard, ListCard };
export type { GridCardProps, ListCardProps };
